import { writable } from 'svelte/store';

export const user = writable(null);
export const selectedChannel = writable(null);
export const firebaseApp = writable();
export const selectedChannelId = writable('');

export const channelFilterText = writable('');
export const showOnlyMyChannels = writable(false);
export const showArchivedChannels = writable(false);
export const mediaCluster = writable({
  status: 'up',
  config: {
    origin: { minSize: 1, maxSize: 20, desiredCapacity: 1 },
    edge: { minSize: 1, maxSize: 2, desiredCapacity: 1 },
  },
});
export const applicationConfig = writable({});

export const selectedChannelTypeFilter = writable(['all']);
export const categories = writable([]);

export const singleChatId = writable();

export const selectedCategory = writable();
